import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
const directionBody = `Welcome to Desert Sage Seminars!

FOR RETURNING STUDENTS: Please update your license expiration date in your Modify Profile folder on your Dashboard to clear the system for your NEW cycle

Where to Find Your Classes To Begin

*SELECT YOUR OWN package of (3 or 6) classes

Click on Available Classes folder
Click button in box to choose your class
Click on the Enroll Me button
Click on My Courses folder
Click on class Title to enter the class
Click the YOUR CLASS button to begin

*PRESET Package of (6 or 8) classes:
Click on My Classes folder
Click on class Title to enter the class
Click the YOUR CLASS button to begin

*SINGLE Class
Click on your My Classes folder
Click on class Title to enter class
Click on YOUR CLASS button to begin`;
export function EditDirectionText() {
  const navigate = useNavigate();
  return <div className="space-y-4" data-id="element-722" data-mp="2ntc8i8w21qhy">
      <div className="flex items-center justify-between" data-id="element-723" data-mp="2sl3tm3wfz40p">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-724" data-mp="2smomzq70sgwz">
          Edit Direction Text
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/admin-area')} data-id="element-725" data-mp="2evtmb16od64h">
          ← Back to Admin Area
        </Button>
      </div>

      <Card data-id="element-726" data-mp="3bjge2lst00bl">
        <CardContent className="pt-6" data-id="element-727" data-mp="3bhvkayebcles">
          <form className="space-y-5" data-id="element-728" data-mp="2xl9odsy0d6n0">
            <Input label="Title" defaultValue="Direction" data-id="element-729" data-mp="2xk6ztro5rga9" />

            <div data-id="element-730" data-mp="32iryvnrobtx4">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-731" data-mp="32i8fs3qaezhi">
                Body
              </label>
              <div className="border border-slate-300 rounded-md overflow-hidden" data-id="element-732" data-mp="1m409ljptr2s1">
                <div className="flex items-center gap-0.5 px-2 py-1 bg-slate-100 border-b border-slate-300 flex-wrap" data-id="element-733" data-mp="1r5zbsq9tvtne">
                  <button type="button" className="px-1.5 py-0.5 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-734" data-mp="3svoc1wwt3pk9">
                    Source
                  </button>
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-735" data-mp="3f1472jpkh2lp" />
                  {['📄', '📋', '✂', '🗑', '↩', '↪'].map((ic, i) => <button key={i} type="button" className="px-1 py-0.5 text-xs border border-transparent hover:border-slate-300 hover:bg-white rounded text-slate-500" data-id="element-736" data-mp="3a0zn2jpg9pqq" data-mpi={i}>
                      {ic}
                    </button>)}
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-737" data-mp="yd9txcaphw7b" />
                  {['🔍', '🔤', '🖊'].map((ic, i) => <button key={i} type="button" className="px-1 py-0.5 text-xs border border-transparent hover:border-slate-300 hover:bg-white rounded text-slate-500" data-id="element-738" data-mp="uczktqrmapo8" data-mpi={i}>
                      {ic}
                    </button>)}
                </div>
                <div className="flex items-center gap-0.5 px-2 py-1 bg-slate-100 border-b border-slate-300 flex-wrap" data-id="element-739" data-mp="2m1qm8cdba08y">
                  {['B', 'I', 'U', 'S'].map(t => <button key={t} type="button" className="w-6 h-6 text-xs font-bold border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-700" data-id="element-740" data-mp="1tcjnbc9y38n6">
                      {t}
                    </button>)}
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-741" data-mp="2783xnjblyiiz" />
                  {['≡', '≣', '❝', '»'].map((t, i) => <button key={i} type="button" className="w-6 h-6 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-742" data-mp="3ip3w6wojttlg" data-mpi={i}>
                      {t}
                    </button>)}
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-743" data-mp="3q9eg8ta5scrp" />
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-744" data-mp="3m7kml4yds911">
                    <option data-id="element-745" data-mp="41y3gelvxsrv">Styles</option>
                  </select>
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-746" data-mp="403k34q9i8pw">
                    <option data-id="element-747" data-mp="3v7z8a5f9bq52">Format</option>
                  </select>
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-748" data-mp="dqpqq9g03owg">
                    <option data-id="element-749" data-mp="8tpknyj5im5c">Font</option>
                  </select>
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-750" data-mp="ms63gnuag33u">
                    <option data-id="element-751" data-mp="htcloj7yxpxv">Size</option>
                  </select>
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-752" data-mp="hv5vu8hsisam" />
                  {['A', 'A', '⊞', '⊟', '⊕', '?'].map((t, i) => <button key={i} type="button" className="w-6 h-6 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-753" data-mp="16dz9f8k2xzwv" data-mpi={i}>
                      {t}
                    </button>)}
                </div>
                <textarea className="w-full p-3 text-sm focus:outline-none resize-y min-h-[300px] bg-white" defaultValue={directionBody} data-id="element-754" data-mp="inlnlzs38xaq" />
              </div>
            </div>

            <div className="pt-2" data-id="element-755" data-mp="8sa99iklds3i">
              <Button type="submit" data-id="element-756" data-mp="dpafbthfyuum">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}